import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import BlockList from 'ui/molecules/BlockList'
import Text from 'ui/Text'

function BuilderSideMenuConditionalRules() {
  const { setConditionalLogicModalOpen, selectedItem, questions, setQuestion } =
    React.useContext(FormBuilderContext)

  const handleClickAlways = () => {
    const question = questions[selectedItem.id]
    setQuestion(selectedItem.id, {
      ...question,
      hidden: false,
      conditional_rule_groups: [],
    })
  }
  const handleClickWhen = () => {
    setConditionalLogicModalOpen(true)
  }

  const handleClickNever = () => {
    const question = questions[selectedItem.id]
    setQuestion(selectedItem.id, {
      ...question,
      hidden: true,
      is_required: false,
      conditional_rule_groups: [],
    })
  }

  const question = questions[selectedItem.id]

  return (
    <div className="text-sm">
      <Text.QuestionTitle>Show this question:</Text.QuestionTitle>
      <BlockList
        items={[
          {
            label: 'Always',
            active:
              question?.conditional_rule_groups?.length === 0 &&
              !question?.hidden,
            onClick: handleClickAlways,
          },
          {
            label: 'When',
            active: question?.conditional_rule_groups?.length > 0,
            onClick: handleClickWhen,
          },
          {
            label: 'Never',
            active: question?.hidden,
            onClick: handleClickNever,
          },
        ]}
      />
    </div>
  )
}

export default BuilderSideMenuConditionalRules
